import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import Selectsearch from "react-select";
import {
	FormGroup,
	Label,	
} from 'reactstrap';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import {
    allTournamentProcess,
    fetchTournamentProcess,
    deleteTournamentProcess,
    allStudents,
    studentTournamentProcess
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import AddItem from './component/addform';
import UpdateItems from './component/editform';

class tournamentprocess extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            viewdiv:true,
            listdiv:false,
            adddiv:false,
            editdiv:false,
            club:'', 
            seldate:'', 
            student:'',       
            country:'',
            round:'',
            eid:'',  
            drvsh_1:'',
            drvsc_1:'',
            fwsh_1:'',
            fwsc_1:'',
            apssh_1:'',
            apssc_1:'',
            wpsh_1:'',
            wpsc_1:'',
            bpsh_1:'',
            bpsc_1:'',
            chpsh_1:'',
            chpsc_1:'',
            putsh_1:'',
            putsc_1:'',
            spssh_1:'',
            spssc_1:'', 
         };    

         
         this.onBackSection = this.onBackSection.bind(this);
         this.deleteForm = this.deleteForm.bind(this);
   } 

    UNSAFE_componentWillMount() {
	   this.props.allStudents();
	}

   selstudent = (evt) =>{
      var stdid=evt.value;
      this.setState({ student:stdid });
      var start='';
      var end='';
      this.props.studentTournamentProcess(stdid, start, end).then((data) => {   
         
         this.setState({ 
             listdiv:true,               
             adddiv:false,
             editdiv:false,
         });

     });
   }

    onAddSession() {
		this.setState({ 
         viewdiv:false,
         listdiv:false,
         editdiv:false,
         adddiv:true,
      });
    } 
      
    onBackSection() {
		this.setState({ 
         editdiv:false,
         adddiv:false,
         listdiv:true,
         viewdiv:true,
      });
	}  


    editAssessment(gid){
        this.props.fetchTournamentProcess(gid).then((data) => {   
            var resdata=data.data;
            var tournamentid=parseInt(resdata[0].gtmd_tournament);
            this.setState({ 
               
                seldate:resdata[0].gtmd_date,      
                country:resdata[0].gtmd_country, 
                student:resdata[0].gtmd_userID, 
                round:resdata[0].gtmd_round, 
                club:tournamentid,
                eid:resdata[0].gtmdID,  
                  drvsh_1:resdata[0].gtmd_drvsh,
                  drvsc_1:resdata[0].gtmd_drvsc,
                  fwsh_1:resdata[0].gtmd_fwsh,
                  fwsc_1:resdata[0].gtmd_fwsc,
                  apssh_1:resdata[0].gtmd_apssh,
                  apssc_1:resdata[0].gtmd_apssc,
                  wpsh_1:resdata[0].gtmd_wpsh,
                  wpsc_1:resdata[0].gtmd_wpsc,
                  bpsh_1:resdata[0].gtmd_bpsh,
                  bpsc_1:resdata[0].gtmd_bpsc,
                  chpsh_1:resdata[0].gtmd_chpsh,
                  chpsc_1:resdata[0].gtmd_chpsc,
                  putsh_1:resdata[0].gtmd_putsh,
                  putsc_1:resdata[0].gtmd_putsc,
                  spssh_1:resdata[0].gtmd_spssh,
                  spssc_1:resdata[0].gtmd_spssc,
              });


            this.setState({ 
                viewdiv:false, 
                listdiv:false,              
                adddiv:false,
                editdiv:true,
       
              });

        });
    }

    deleteForm(data){
      this.data = data;
      this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
      
        if (popupResponse) {
            this.props.deleteTournamentProcess(this.data);
            this.data = ""
        }
    }

    render() {
       const { match, studentlists, tournamentprocesslist, loading } = this.props;
       const allstudent=studentlists.map((stdval) => {  
         return {
            label: stdval.student,  
            value: stdval.uudID
         }
       });
       
       const options = {
            filterType: 'dropdown',
            rowsPerPage: 50,
            rowsPerPageOptions: [50, 100, 150],
            selectableRowsHideCheckboxes: true,
        };

        const columns = [
            { name: "no", label: "NO" },
            { name: "name", label: "NAME" },
            { name: "cdate", label: "DATE" },
            { name: "clubname", label: "TOURNAMENT" },
            { name: "round", label: "ROUND" },
            { name: "action", label: "ACTION" },
            { name: "action1", label: "ACTION1" },
          
        ];
        const tabledata=tournamentprocesslist.map((assmntval,idx) => {     
                     const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval.gtmdID)}><EditOutlinedIcon/></IconButton>;
                     const dbtn=<IconButton  className="text-danger" aria-label="Remove" onClick={ ()=>this.deleteForm(assmntval.gtmdID)}  ><DeleteOutlineOutlinedIcon/></IconButton>;
                
                return {
                no:idx+1,
                name: assmntval.student,
                cdate: assmntval.cdate,
                clubname:assmntval.gtl_name,
                round:assmntval.gtmd_round,
                action: ebtn,
                action1:dbtn,
                
                }
        });

 

       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>Tournament Process | {AppConfig.appTitle}</title>
                <meta name="description" content="Golf" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.tournamentprocess" />} match={match} />
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-4" style={{margin:"0 auto"}}> 
                        <Label for="Select">Student *</Label> 
                        <FormGroup>   
                           <Label for="Select">Student *</Label>                                           
                           <Selectsearch id="student" name="student" placeholder="Select..." options={allstudent} rules={{ required: 'Please select an student'}} value={allstudent.find(obj => obj.value === this.state.student)} onChange={this.selstudent} required/>
                        </FormGroup>
                  </div>
               }  
               {this.state.listdiv && 
                  <div className="col-sm-12 col-md-12">
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Add Tournament Process</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>
               }
               {this.state.adddiv && 
                  <AddItem onClick={this.onBackSection} data={this.state}/>                
               }

               {this.state.editdiv && 
                <UpdateItems onClick={this.onBackSection} data={this.state}/>   
               }

            <ConfirmationDialog
               ref={this.confirmationDialog}
               onConfirm={(res) => this.deleteDataPermanent(res)}
               data={'tournament process'}
            />
                  
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused, tournamentprocess }) => {
	const { tournamentprocesslist, loading } = tournamentprocess;
   const { studentlists } = mostlyused;
	return { tournamentprocesslist, studentlists, loading };
}

export default connect(mapStateToProps, {
    allTournamentProcess,
    fetchTournamentProcess,
    deleteTournamentProcess,
    allStudents,
    studentTournamentProcess
})(tournamentprocess); 